export const CMS_LOADING = 'waitrose/cms/LOADING';
export const CMS_LOADED = 'waitrose/cms/LOADED';
export const CMS_FAILED = 'waitrose/cms/FAILED';
